import { render, staticRenderFns } from "./qyxw.vue?vue&type=template&id=49e6a5ac&scoped=true"
import script from "./qyxw.vue?vue&type=script&lang=js"
export * from "./qyxw.vue?vue&type=script&lang=js"
import style0 from "./qyxw.vue?vue&type=style&index=0&id=49e6a5ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e6a5ac",
  null
  
)

export default component.exports